module.exports = __webpack_public_path__ + "static/peffers-hex-gray-fe0581d85dcb04e320c8473e4296edc9.png";